module.exports = {
    api: {
        URL: 'https://portalapi.nextspin.com'
    },
};